import React, {useMemo} from "react";
import moment from "moment/moment";
import {Typography} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {useGetMLBPlayerGamesStatsByPlayerIdQuery} from "../../../stores/tradefan/tradefan.api";


import "./MLBGamesStats.style.scss";
import "../PlayerGamesStats.style.scss";
import MLBSeasonStats from "./MLBSeasonStats";
import GlobalConst from "../../../constants/GlobalConst";
import {getCurrentSeasonYearsBySportAndSeason} from "../../../constants/SportsConst";
const MLBGamesStats = ({contest}) => {
    const seasonYears = getCurrentSeasonYearsBySportAndSeason(9);

    const queryArgs = useMemo(() => ({
        playerId: contest.PlayerId,
        from: moment().add(-1, 'weeks').toDate().getTime(),
        to: moment().add(1, 'days').endOf('day').toDate().getTime(),
    }), [contest.PlayerId]);



    const {data: gameStats, isLoading} = useGetMLBPlayerGamesStatsByPlayerIdQuery(queryArgs);
    const isPitcher = gameStats?.some(stat => stat.IsPitcher === true);

    const renderHitterTable = () => {
        return <div className="MLBGamesStatsLog">
            <React.Fragment>
                <div className="GameStats">
                    <div className="tableContainer">
                        <table className={"gameLogTable"}>
                            <thead>
                            <tr>{
                                <React.Fragment>
                                    <th>Date vs Opp</th>
                                    <th>1B</th>
                                    <th>2B</th>
                                    <th>3B</th>
                                    <th className={contest?.StatsKey === "Hitting.HRR" ? "highlight gold-gradient-text" : ""}>H</th>
                                    <th className={contest?.StatsKey === "Hitting.HRR" ? "highlight gold-gradient-text" : ""}>R</th>
                                    <th className={contest?.StatsKey === "Hitting.HRR" ? "highlight gold-gradient-text" : ""}>RBI</th>
                                    <th>BB</th>
                                    <th>SB</th>
                                    <th>CS</th>
                                    {/*<th>FP</th>*/}
                                </React.Fragment>
                            }</tr>
                            </thead>
                            {gameStats?.filter((gameStats) => !gameStats.IsPitcher)
                                .sort((a, b) => moment(a.DateTime).isBefore(moment(b.DateTime)) ? 1 : -1)
                                .map((gameStats) => {

                                    let fp = gameStats.IsPitcher ? gameStats.Pitching.FantasyPoints :
                                        gameStats.Hitting.FantasyPoints;

                                    return <tbody key={gameStats.GameId}>
                                    <tr>
                                        {
                                            <React.Fragment>
                                                <td><span
                                                    className="date">{moment(gameStats.DateTime).format("MM/DD")}</span>
                                                    <span className="vs"> vs {gameStats.Opponent} </span>
                                                </td>
                                                <td>{gameStats.Hitting.Singles}</td>
                                                <td>{gameStats.Hitting.Doubles}</td>
                                                <td>{gameStats.Hitting.Triples}</td>
                                                <td className={contest?.StatsKey === "Hitting.HRR" ? "highlight gold-gradient-text" : ""}>{gameStats.Hitting.Hits}</td>
                                                <td className={contest?.StatsKey === "Hitting.HRR" ? "highlight gold-gradient-text" : ""}>{gameStats.Hitting.Runs}</td>
                                                <td className={contest?.StatsKey === "Hitting.HRR" ? "highlight gold-gradient-text" : ""}>{gameStats.Hitting.RunsBattedIn}</td>
                                                <td>{gameStats.Hitting.Walks}</td>
                                                <td>{gameStats.Hitting.StolenBases}</td>
                                                <td>{gameStats.Hitting.CaughtStealing}</td>
                                                {/*<td>{fp.toFixed(1).replace(".0", "")}</td>*/}
                                            </React.Fragment>
                                        }
                                    </tr>
                                    </tbody>
                                })}
                        </table>
                    </div>
                </div>
            </React.Fragment>
        </div>
    }

    const renderPitcherTable = () => {
        return <div className="MLBGamesStatsLog">
            <React.Fragment>
                <div className="GameStats">
                    <div className="tableContainer">
                        <table className={"gameLogTable"}>
                            <thead>
                            <tr>{
                                <React.Fragment>
                                    <th>Date vs Opp</th>
                                    <th>IP</th>
                                    <th className={contest?.StatsKey === "Pitching.Strikeouts" ? "highlight gold-gradient-text" : ""}>K</th>
                                    <th>ER</th>
                                    <th>H</th>
                                    <th>BB</th>
                                    <th>HBP</th>
                                    <th>CG</th>
                                    <th>CSO</th>
                                    <th>NH</th>
                                    {/*<th>FP</th>*/}
                                </React.Fragment>
                            }</tr>
                            </thead>
                            {gameStats?.filter((gameStats) => !gameStats.IsPitcher)
                                .sort((a, b) => moment(a.DateTime).isBefore(moment(b.DateTime)) ? 1 : -1)
                                .map((gameStats) => {

                                    let fp = gameStats.IsPitcher ? gameStats.Pitching.FantasyPoints :
                                        gameStats.Hitting.FantasyPoints;

                                    return <tbody key={gameStats.GameId}>
                                    <tr>
                                        {
                                            <React.Fragment>
                                                <td><span
                                                    className="date">{moment(gameStats.DateTime).format("MM/DD")}</span>
                                                    <span className="vs"> vs {gameStats.Opponent} </span>
                                                </td>
                                                <td>{gameStats.Pitching.InningsPitched.toFixed(0)}</td>
                                                <td  className={contest?.StatsKey === "Pitching.Strikeouts" ? "highlight gold-gradient-text" : ""}>{gameStats.Pitching.Strikeouts}</td>
                                                <td>{gameStats.Pitching.EarnedRuns}</td>
                                                <td>{gameStats.Pitching.Hits}</td>
                                                <td>{gameStats.Pitching.Walks}</td>
                                                <td>{gameStats.Pitching.HitByPitch}</td>
                                                <td>{gameStats.Pitching.CompleteGames}</td>
                                                <td>{gameStats.Pitching.ShutOuts}</td>
                                                <td>{gameStats.Pitching.NoHitters}</td>
                                                {/*<td>{fp.toFixed(1).replace(".0", "")}</td>*/}
                                            </React.Fragment>
                                        }
                                    </tr>
                                    </tbody>
                                })}
                        </table>
                    </div>
                </div>
            </React.Fragment>
        </div>
    }

    return (
        <>
            {GlobalConst.FEATURES.SHOW_PLAYER_SEASON_STATS.MLB &&
                <MLBSeasonStats playerId={contest.PlayerId}
                                isPitcher={isPitcher}
                                seasonYears={seasonYears}
                />}
            <div className="MLBgameLogSection">
                <Typography variant="h6" className="gameLogTitle">
                    {seasonYears[0]} - {seasonYears[1]} <FormattedMessage id={"popUp.contestPreview.gameLog"}/>
                </Typography>
                {!isPitcher && renderHitterTable()}
                {isPitcher && renderPitcherTable()}
            </div>
        </>
    )
}

export default MLBGamesStats;